import Response from '../base/Response';

export default class PreconditionalResponse extends Response {

}
